/**
 * 详情页路由参数读写工具
 *
 * 背景：详情页原先使用查询参数定位资源（/product?id=xxx、/app?title=资产管理），
 * 这种形式在构建期无法枚举，预渲染（P0-1）拿不到 URL 列表。
 * 改造后统一为路径参数（/product/xxx、/app/xxx），本文件负责：
 *   1. 生成路径片段（toSegment / detailPath）
 *   2. 读取参数时优先取路径参数，取不到再回落到查询参数（兼容尚未跳转的旧链接）
 */

// 判断是否为 id 形态：GUID 或纯数字
var ID_RE = /^[0-9a-fA-F-]{8,}$|^[0-9]+$/

export function toSegment(value) {
  if (value === undefined || value === null || value === '') return ''
  var str = String(value)
  // id 形态直接透传，中文名称做 URL 编码，保证两端可逆
  return ID_RE.test(str) ? str : encodeURIComponent(str)
}

export function detailPath(base, value) {
  var seg = toSegment(value)
  return seg ? base + '/' + seg : base
}

/**
 * 读取路由参数，优先路径参数，回落查询参数
 * @param {Object} route this.$route
 * @param {String} key 参数名
 */
export function param(route, key) {
  var fromPath = route.params && route.params[key]
  if (fromPath !== undefined && fromPath !== null && fromPath !== '') return fromPath
  var fromQuery = route.query && route.query[key]
  if (fromQuery !== undefined && fromQuery !== null && fromQuery !== '') return fromQuery
  return undefined
}

/**
 * 把当前带查询参数的旧地址替换为对应的新路径地址
 * 用于旧链接 301 之外的兜底：即便 nginx 规则没覆盖到，用户也能落到规范 URL
 * @param {Object} route this.$route
 * @param {String} base 路径前缀，如 '/product'
 * @param {String[]} keys 需要迁移的参数名，按顺序拼进路径
 * @returns {String|null} 新路径，无需迁移时返回 null
 */
export function canonicalPath(route, base, keys) {
  var segs = []
  keys.forEach(function (k) {
    var v = route.query && route.query[k]
    if (v !== undefined && v !== null && v !== '') segs.push(toSegment(v))
  })
  if (!segs.length) return null
  return base + '/' + segs.join('/')
}
